export default "__VITE_ASSET__CMGtOB1R__"